const VideoAssets = {
  starsBG: 'assets/video/BG_stars.mp4',
  transmutation1: 'assets/video/transmutation_1.mp4'
}

export default VideoAssets
